'use client'

import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import { Switch } from '@/components/ui/switch'
import type { VoicemailData } from '@/lib/pbx/flow/types'

interface VoicemailPanelProps {
  data: VoicemailData
  onUpdate: (data: Partial<VoicemailData>) => void
}

export function VoicemailPanel({ data, onUpdate }: VoicemailPanelProps) {
  return (
    <div className="p-4 space-y-4">
      <div className="space-y-2">
        <Label htmlFor="greeting_message">Greeting Message (TTS)</Label>
        <Textarea
          id="greeting_message"
          value={data.greeting_message || ''}
          onChange={(e) => onUpdate({ greeting_message: e.target.value })}
          placeholder="Leave your message after the beep..."
          rows={3}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="greeting_audio_url">Or Audio URL</Label>
        <Input
          id="greeting_audio_url"
          value={data.greeting_audio_url || ''}
          onChange={(e) => onUpdate({ greeting_audio_url: e.target.value })}
          placeholder="https://example.com/greeting.mp3"
        />
        <p className="text-xs text-muted-foreground">
          Audio URL takes precedence over TTS
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="max_duration">Max Duration (seconds)</Label>
        <Input
          id="max_duration"
          type="number"
          min={10}
          max={600}
          value={data.max_duration || 120}
          onChange={(e) => onUpdate({ max_duration: parseInt(e.target.value, 10) })}
        />
      </div>

      <div className="flex items-center justify-between">
        <div className="space-y-0.5">
          <Label>Transcription</Label>
          <p className="text-xs text-muted-foreground">
            Convert voicemail to text (English only)
          </p>
          <p className="text-xs text-yellow-600">
            Paid Twilio feature (~$0.05/min)
          </p>
        </div>
        <Switch
          checked={data.transcribe || false}
          onCheckedChange={(checked) => onUpdate({ transcribe: checked })}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="notify_email">Notification Email</Label>
        <Input
          id="notify_email"
          type="email"
          value={data.notify_email || ''}
          onChange={(e) => onUpdate({ notify_email: e.target.value })}
          placeholder="notify@example.com"
        />
        <p className="text-xs text-muted-foreground">
          Optional email for new voicemail notifications
        </p>
      </div>
    </div>
  )
}
